import { render, staticRenderFns } from "./CodeItemDetailPanel.vue?vue&type=template&id=5e602bae&scoped=true"
import script from "./CodeItemDetailPanel.vue?vue&type=script&lang=js"
export * from "./CodeItemDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./CodeItemDetailPanel.vue?vue&type=style&index=0&id=5e602bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e602bae",
  null
  
)

export default component.exports